import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01b1797f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-4" }, null, -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-sm-4" }
const _hoisted_7 = { class: "col-sm-4" }
const _hoisted_8 = {
  key: 0,
  class: "col-sm-4"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-sm-4" }
const _hoisted_11 = {
  key: 1,
  class: "form-group w-100"
}
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-4" }
const _hoisted_14 = { class: "col-sm-4" }
const _hoisted_15 = { class: "col-sm-4" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-sm-4" }
const _hoisted_18 = { class: "col-sm-4" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-sm-4" }
const _hoisted_21 = {
  key: 0,
  class: "col-sm-4"
}
const _hoisted_22 = { class: "d-flex justify-content-center mt-5" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "legend form-group" }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center\" data-v-01b1797f><p class=\"me-4 mb-0\" data-v-01b1797f>t = tons;</p><p class=\"me-4 mb-0\" data-v-01b1797f>p = people;</p><p class=\"me-4 mb-0\" data-v-01b1797f>km = kilometres;</p><p class=\"me-4 mb-0\" data-v-01b1797f>h = hours;</p></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_form_field, {
              type: "select-string",
              list: _ctx.destinations,
              modelValue: _ctx.travelLogisticMobilityEmissionData.destination,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.travelLogisticMobilityEmissionData.destination) = $event)),
              labelKey: "Allocation",
              labelValue: "Allocation",
              placeholderKey: "Select an allocation",
              placeholderValue: "Select an allocation",
              class: "mb-3"
            }, null, 8, ["list", "modelValue"])
          ])
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_form_field, {
              type: "select-string",
              list: _ctx.timeFrameList,
              modelValue: _ctx.timeFrameSelected,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.timeFrameSelected) = $event)),
              labelKey: "Time frame",
              labelValue: "Time frame",
              placeholderKey: "Select a time frame",
              placeholderValue: "Select a time frame"
            }, null, 8, ["list", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_form_field, {
              type: "text",
              modelValue: _ctx.saveModel.year,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.saveModel.year) = $event)),
              labelKey: "Year",
              labelValue: "Year",
              placeholderKey: "Year",
              placeholderValue: "Year"
            }, null, 8, ["modelValue"])
          ]),
          (_ctx.timeFrameSelected == _ctx.viewModel.TimeFrame.Month)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_form_field, {
                  type: "select",
                  list: _ctx.monthList,
                  modelValue: _ctx.saveModel.month,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.saveModel.month) = $event)),
                  labelKey: "Month",
                  labelValue: "Month",
                  placeholderKey: "Month",
                  placeholderValue: "Month"
                }, null, 8, ["list", "modelValue"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_ctx.premises.length > 0)
              ? (_openBlock(), _createBlock(_component_form_field, {
                  key: 0,
                  type: "select",
                  list: _ctx.premises,
                  modelValue: _ctx.saveModel.selectedPremises.identifier,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.saveModel.selectedPremises.identifier) = $event)),
                  labelKey: "Premises type",
                  labelValue: "Premises type",
                  placeholderKey: "Select a premises type",
                  placeholderValue: "Select a premises type"
                }, null, 8, ["list", "modelValue"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Premises type",
                    text: "Premises type",
                    class: "input_title d-block fw_700 mb-2"
                  }),
                  (_ctx.premises.length == 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-primary",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addPremises()))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Add new premises",
                          text: "Add new premises"
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_form_field, {
              type: "select-string",
              list: _ctx.referencesFlow1,
              modelValue: _ctx.travelLogisticMobilityEmissionData.referenceFlow1,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.travelLogisticMobilityEmissionData.referenceFlow1) = $event)),
              labelKey: "Travel Type",
              labelValue: "Travel Type",
              placeholderKey: "Select a travel type",
              placeholderValue: "Select a travel type",
              onChange: _ctx.referenceFlow1Updated
            }, null, 8, ["list", "modelValue", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_form_field, {
              type: "select-string",
              list: _ctx.transportModes,
              modelValue: _ctx.travelLogisticMobilityEmissionData.transportMode,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.travelLogisticMobilityEmissionData.transportMode) = $event)),
              labelKey: "Transport Mode",
              labelValue: "Transport Mode",
              placeholderKey: "Select a transport mode",
              placeholderValue: "Select a transport mode",
              onChange: _ctx.transportModeUpdated
            }, null, 8, ["list", "modelValue", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_form_field, {
              type: "select-string",
              list: _ctx.referencesFlow2,
              modelValue: _ctx.travelLogisticMobilityEmissionData.referenceFlow2,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.travelLogisticMobilityEmissionData.referenceFlow2) = $event)),
              labelKey: "Transport Type",
              labelValue: "Transport Type",
              placeholderKey: "Select a transport type",
              placeholderValue: "Select a transport type",
              onChange: _ctx.referenceFlow2Updated
            }, null, 8, ["list", "modelValue", "onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_form_field, {
              type: "select-string",
              list: _ctx.geographies,
              modelValue: _ctx.travelLogisticMobilityEmissionData.geography,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.travelLogisticMobilityEmissionData.geography) = $event)),
              labelKey: "Geography",
              labelValue: "Geography",
              placeholderKey: "Select a place in the world",
              placeholderValue: "Select a place in the world",
              onChange: _ctx.geographyUpdated
            }, null, 8, ["list", "modelValue", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(), _createBlock(_component_form_field, {
              type: "select-string",
              list: _ctx.uoms,
              modelValue: _ctx.travelLogisticMobilityEmissionData.uom,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.travelLogisticMobilityEmissionData.uom) = $event)),
              labelKey: "Reference Unit",
              labelValue: "Reference Unit",
              placeholderKey: "Select a reference unit",
              placeholderValue: "Select a reference unit",
              key: _ctx.rndUoms
            }, null, 8, ["list", "modelValue"]))
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_form_field, {
              type: "number",
              step: 0.1,
              modelValue: _ctx.saveModel.consumption,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.saveModel.consumption) = $event)),
              labelKey: 'Consumption' + _ctx.firstConsumptionType,
              labelValue: 'Consumption' + _ctx.firstConsumptionType,
              placeholderKey: 'Consumption' + _ctx.firstConsumptionType,
              placeholderValue: 'Consumption' + _ctx.firstConsumptionType
            }, null, 8, ["modelValue", "labelKey", "labelValue", "placeholderKey", "placeholderValue"])
          ]),
          (_ctx.hasSecondConsumptionValue)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_component_form_field, {
                  type: "number",
                  step: 0.1,
                  modelValue: _ctx.saveModel.consumptionSecondValue,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.saveModel.consumptionSecondValue) = $event)),
                  labelKey: 'Consumption' + _ctx.secondConsumptionType,
                  labelValue: 'Consumption' + _ctx.secondConsumptionType,
                  placeholderKey: 'Consumption' + _ctx.secondConsumptionType,
                  placeholderValue: 'Consumption' + _ctx.secondConsumptionType
                }, null, 8, ["modelValue", "labelKey", "labelValue", "placeholderKey", "placeholderValue"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("button", {
            class: "btn btn-tertiary px-5",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.calculateAndSave())),
            disabled: _ctx.calculateDisabled
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Calculate & Record",
              text: "Calculate & Record"
            })
          ], 8, _hoisted_23)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_localized_text, {
            localizedKey: "Reference Unit Legend",
            text: "Reference Unit Legend",
            class: "input_title",
            type: "label"
          }),
          _hoisted_25
        ])
      ]))
    : _createCommentVNode("", true)
}